import React from 'react'
import SearchComponent from '../components/Search/SearchComponent'

function Search() {
  return (
    <SearchComponent />
  )
}

export default Search